<template>
  <div class="content">
    <div
      class="item"
      v-for="item in list"
      :key="item.index"
      @click="goDetail(item.index)"
    >
      <div class="item_title">{{ item.title }}</div>
      <img class="item_right" src="@/assets/icon/icon-right.svg"></img>
    </div>
  </div>
</template>

<script>
import "./rem";
export default {
  data() {
    return {
      list: [
        {
          title: "订购提醒",
          index: "1",
        },
        {
          title: "订购说明",
          index: "2",
        },
        {
          title: "支付方式",
          index: "3",
        },
        {
          title: "售后服务",
          index: "4",
        },
        {
          title: "关于我们",
          index: "5",
        },
      ],
    };
  },
  methods: {
    goDetail(index) {
      this.$router.push({
        path: "/problem/detail",
        query: {
          index: index,
        },
      });
    },
  },
  created() {},

  mounted() {},
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 30px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.9);
  padding-top: 10px;
}
.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  font-weight: bold;
  &_right {
    width: 30px;
    height: 30px;
    color: rgba(0, 0, 0, 0.47);
  }
}
</style>
